/////////////////////////////Betryaed King/////////////////////////////
export const BK_ID = 1;
export const BK_NAME = "Betryaed King";
export const BK_ICON =
  "https://github.com/outofs/dies-irae/blob/master/src/img/1.png?raw=true";
export const BK_STARTED_HP = 1000;
export const BK_HP = 1000;
export const BK_STARTED_ATTACK = 100;
export const BK_ATTACK = 100;
export const BK_STARTED_DEFENCE = 0.3;
export const BK_DEFENCE = 0.3;
export const BK_STARTED_AGILITY = 20;
export const BK_AGILITY = 20;
export const BK_HEALING = 80;
export const BK_HEALING_TURNS = 3;
export const BK_DAMAGE_MOVEMENTS = [];
export const BK_SKILL1_ENABLE = false;
export const BK_SKILL2_ENABLE = false;
export const BK_SKILL3_ENABLE = false;
export const BK_TURNS_SKILL1 = 0;
export const BK_TURNS_SKILL2 = 0;
export const BK_TURNS_SKILL3 = 0;

/////////////////////////////Siren/////////////////////////////
export const SI_ID = 2;
export const SI_NAME = "Siren";
export const SI_ICON =
  "https://github.com/outofs/dies-irae/blob/master/src/img/2.png?raw=true";
export const SI_STARTED_HP = 800;
export const SI_HP = 800;
export const SI_STARTED_ATTACK = 90;
export const SI_ATTACK = 90;
export const SI_STARTED_DEFENCE = 0.1;
export const SI_DEFENCE = 0.1;
export const SI_STARTED_AGILITY = 40;
export const SI_AGILITY = 40;
export const SI_HEALING = 120;
export const SI_HEALING_TURNS = 3;
export const SI_DAMAGE_MOVEMENTS = [];
export const SI_SKILL1_ENABLE = false;
export const SI_SKILL2_ENABLE = false;
export const SI_SKILL3_ENABLE = false;
export const SI_TURNS_SKILL1 = 0;
export const SI_TURNS_SKILL2 = 0;
export const SI_TURNS_SKILL3 = 0;

/////////////////////////////Swamp Demon/////////////////////////////
export const SD_ID = 3;
export const SD_NAME = "Swamp Demon";
export const SD_ICON =
  "https://github.com/outofs/dies-irae/blob/master/src/img/3.png?raw=true";
export const SD_STARTED_HP = 1100;
export const SD_HP = 1100;
export const SD_STARTED_ATTACK = 90;
export const SD_ATTACK = 90;
export const SD_STARTED_DEFENCE = 0.1;
export const SD_DEFENCE = 0.1;
export const SD_STARTED_AGILITY = 30;
export const SD_AGILITY = 30;
export const SD_HEALING = 120;
export const SD_HEALING_TURNS = 3;
export const SD_DAMAGE_MOVEMENTS = [];
export const SD_SKILL1_ENABLE = false;
export const SD_SKILL2_ENABLE = false;
export const SD_SKILL3_ENABLE = false;
export const SD_TURNS_SKILL1 = 0;
export const SD_TURNS_SKILL2 = 0;
export const SD_TURNS_SKILL3 = 0;
export const SD_SKILL1_DAMAGE_PROGRESSION = 0;

export const SHOW__DAMAGE__TIME = 700;
